/* tslint:disable */
/* eslint-disable */
export enum ExtraExtraTypeEnum {
  Wheels = 'Wheels',
  Towbar = 'Towbar',
  Tint = 'Tint',
  Snorkel = 'Snorkel',
  Bullbar = 'Bullbar',
  Mags = 'Mags',
  Hardlid = 'Hardlid',
  Other = 'Other'
}
